export enum JobStatus {
  Normal,
  Error,
  InUse,
  Closed
}
